import React, { useState } from 'react';
import styles from './Dropdown.module.css';
import { IoChevronDownOutline } from 'react-icons/io5';
import clsx from 'clsx';

const Dropdown = ({
  label = 'Select',
  options = [],
  bgColor,
  onChange, // callback to parent
  className = '',
  showAllOption = true, // whether to show "All" option
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null); // null = default

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelectOption = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    if (onChange) onChange(option);
  };

  const handleSelectAll = () => {
    setSelectedOption(null);
    setIsOpen(false);
    if (onChange) onChange(null); // null means reset filter
  };

  const styleVars = { '--custom_color': bgColor };

  return (
    <div
      className={clsx(styles.dropdownContainer, className)}
      style={styleVars}
    >
      <div className={styles.Dropdown} onClick={handleToggle}>
        <div className={styles.textWithIcon}>
          <span>{selectedOption || label}</span>
          <IoChevronDownOutline
            size={16}
            className={`${styles.icon} ${isOpen ? styles.iconOpen : ''}`}
          />
        </div>
      </div>

      {isOpen && (
        <ul className={styles.optionsList}>
          {showAllOption && (
            <li className={styles.optionItem} onClick={handleSelectAll}>
              All {label}
            </li>
          )}
          {options.map((option, index) => (
            <li
              key={index}
              className={styles.optionItem}
              onClick={() => handleSelectOption(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
